import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../../../services/base.service';
import { ScheduleType } from '../models/schedule-type';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService extends BaseService<ScheduleType> {

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string    
  ) {
    super(http,rootUrl,'TimeTracking/ScheduleType');
  }
}
